import {query} from '@di-nxt/query';
import {Absence, Shift, Task} from '../../../../entities';
import {isDateInRange} from '../../functions';
import {ShiftWithTasks} from '../../types';

export const getShiftsWithTasksAndUnassignedTasks = (
  tasks: Task[],
  shifts: Shift[],
  absences: Absence[],
): {
  shiftsWithTasks: ShiftWithTasks[];
  unassignedTasks: Task[];
} => {
  const tasksGroupedByShift = query(shifts).outerGroupByJoin(
    tasks,
    'id',
    'shiftId',
    (shift, tasksGrouped): ShiftWithTasks | {shift: undefined; tasks: Task[]} =>
      shift
        ? {
            active:
              absences.find(
                a =>
                  a.membershipId === shift.membershipId &&
                  isDateInRange(shift.distrDate, a.fromDate, a.toDate),
              ) === undefined,
            shift,
            tasks: query(tasksGrouped)
              .orderBy(t => t.taskSequence)
              .toArray(),
            totalTasksHours:
              query(tasksGrouped).sum('durationMinutesEstimated') / 60,
          }
        : {
            shift: undefined,
            tasks: tasksGrouped,
          },
  );

  const shiftsWithTasks = tasksGroupedByShift
    .where(tg => !!tg.shift)
    .toArray() as ShiftWithTasks[];

  const unassignedTasks =
    tasksGroupedByShift.singleOrUndefined(tg => !tg.shift)?.tasks ?? [];

  return {shiftsWithTasks, unassignedTasks};
};
